import React, { lazy, Suspense, useState } from 'react';
import { StoreIcon } from "@hm-group/fabric-icons/icons/StoreIcon";
import { default as IS_CLIENT } from "@pb/utils/constants/isClient";
import cn from 'classnames';
import { CTALink } from "../../ui/CTA";
import Modal from "../../ui/Modal";
import Spinner from "../../ui/Spinner";
import SeeMoreStores from './components/SeeMoreStores';
import SeeSizes from './components/SeeSizes';
import styles from './ProductStoreLocator.module.scss';
const Locator = lazy(() => import("../Locator"));
const ProductStoreLocator = ({ storeSearchData, imageProductSrc, imageModelSrc, inStoreStock, title, regularPrice, redPrice, variantCode, articleCode, onProductStoreLocatorCTAClick, onProductStoreLocatorWithSizeClick, isPdpFis, optimizelyVariantsName = null, mySelectedStore, storeInformationWithSize, shouldShowAvailableSizes = false, fisLabels, showStoreCardWithSeparator = false, linkTextDecoration = 'underline', iconMargin = 'none', iconSize = 'small', }) => {
    var _a, _b, _c, _d, _e, _f;
    const [isStoreLocatorOpen, setIsStoreLocatorOpen] = useState(false);
    const [isStoreOpen, setIsStoreOpen] = useState('');
    if (!storeSearchData) {
        return null;
    }
    let updatedArticleCode = articleCode;
    if (isPdpFis && IS_CLIENT) {
        const selectedSizeCode = (_a = window.selectedSize) === null || _a === void 0 ? void 0 : _a.substring(((_b = window.selectedSize) === null || _b === void 0 ? void 0 : _b.length) - 3);
        updatedArticleCode = selectedSizeCode ? articleCode + selectedSizeCode : articleCode;
    }
    const artCode = (_c = updatedArticleCode === null || updatedArticleCode === void 0 ? void 0 : updatedArticleCode.toString()) !== null && _c !== void 0 ? _c : '';
    const lastThreeNumbersInArticleCode = artCode.substring(artCode.length - 3);
    const productTile = {
        image: IS_CLIENT && isPdpFis && window.pdpthumbNailImage
            ? window.pdpthumbNailImage
            : imageProductSrc || imageModelSrc || '',
        name: title || '',
        price: regularPrice || '',
        reducedPrice: redPrice || '',
        productCodeName: storeSearchData.articleCodeText || '',
        productCode: (articleCode === null || articleCode === void 0 ? void 0 : articleCode.toString()) || variantCode || '',
        size: updatedArticleCode && updatedArticleCode.length > 10
            ? (_e = (_d = storeSearchData.allProductSizes) === null || _d === void 0 ? void 0 : _d.find(({ sizeCode }) => sizeCode === lastThreeNumbersInArticleCode)) === null || _e === void 0 ? void 0 : _e.sizeName
            : '',
    };
    const selectedStore = (_f = storeSearchData.stores) === null || _f === void 0 ? void 0 : _f.filter(({ storeCode }) => storeCode === isStoreOpen)[0];
    const openStoreModal = (data) => {
        setIsStoreOpen(data);
    };
    const closeButtonText = storeSearchData.closeLabel || 'Close';
    const ctaText = inStoreStock
        ? storeSearchData.findInStoreTriggerText
        : storeSearchData.findInStoreNotAvailableText;
    // Only for A/B testing purposes
    // TODO: remove when iterative testing of component is completed. BTPRDA-1142
    let findInStoreElement = null;
    if (optimizelyVariantsName === 'variant1') {
        findInStoreElement = (React.createElement(SeeSizes, { storeSearchData: storeSearchData, mySelectedStore: mySelectedStore, "aria-label": storeSearchData.findInStoreTriggerAriaLabel, labels: fisLabels, onClick: () => {
                if (storeSearchData.trackOptimizelyEvent) {
                    if (isPdpFis) {
                        storeSearchData.trackOptimizelyEvent('click_fis_pdp');
                    }
                    else {
                        storeSearchData.trackOptimizelyEvent('find_in_store_from_favourite');
                    } // TODO: BTBPSDL-200 remove storeSearchData.trackOptimizelyEvent once AB test will complete
                }
                if (productTile.size) {
                    onProductStoreLocatorWithSizeClick === null || onProductStoreLocatorWithSizeClick === void 0 ? void 0 : onProductStoreLocatorWithSizeClick(articleCode);
                }
                else {
                    onProductStoreLocatorCTAClick === null || onProductStoreLocatorCTAClick === void 0 ? void 0 : onProductStoreLocatorCTAClick(articleCode);
                }
                setIsStoreLocatorOpen(true);
            }, disabled: !inStoreStock, onClickEvents: {
                onTracking() {
                    if (storeSearchData.trackOptimizelyEvent) {
                        storeSearchData.trackOptimizelyEvent('click_pdp_fis_tooltip'); // TODO: BTBPSDL-200 remove storeSearchData.trackOptimizelyEvent once AB test will complete
                    }
                },
            } }));
    }
    else if (optimizelyVariantsName === 'variant2' && shouldShowAvailableSizes) {
        findInStoreElement = (React.createElement(SeeMoreStores, { storeInformationWithSize: storeInformationWithSize, storeSearchData: storeSearchData, mySelectedStore: mySelectedStore, "aria-label": storeSearchData.findInStoreTriggerAriaLabel, labels: fisLabels, onClick: () => {
                if (storeSearchData.trackOptimizelyEvent) {
                    if (isPdpFis) {
                        storeSearchData.trackOptimizelyEvent('click_fis_pdp');
                    }
                    else {
                        storeSearchData.trackOptimizelyEvent('find_in_store_from_favourite');
                    } // TODO: BTBPSDL-200 remove storeSearchData.trackOptimizelyEvent once AB test will complete
                }
                if (productTile.size) {
                    onProductStoreLocatorWithSizeClick === null || onProductStoreLocatorWithSizeClick === void 0 ? void 0 : onProductStoreLocatorWithSizeClick(articleCode);
                }
                else {
                    onProductStoreLocatorCTAClick === null || onProductStoreLocatorCTAClick === void 0 ? void 0 : onProductStoreLocatorCTAClick(articleCode);
                }
                setIsStoreLocatorOpen(true);
            }, disabled: !inStoreStock, onClickEvents: {
                onTracking() {
                    if (storeSearchData.trackOptimizelyEvent)
                        storeSearchData.trackOptimizelyEvent('click_pdp_fis_tooltip'); // TODO: BTBPSDL-200 remove storeSearchData.trackOptimizelyEvent once AB test will complete
                },
            } }));
    }
    else if (optimizelyVariantsName === null ||
        (optimizelyVariantsName === 'variant2' && !shouldShowAvailableSizes)) {
        findInStoreElement = (React.createElement(CTALink, { Tag: "button", className: cn(linkTextDecoration === 'none' ? styles.triggerButton : styles.triggerButtonDefault, !inStoreStock && styles.disabled, iconMargin === 'small' && styles.iconMargin), title: ctaText, "aria-label": storeSearchData.findInStoreTriggerAriaLabel, iconElement: React.createElement(StoreIcon, { size: iconSize }), onClick: () => {
                if (storeSearchData.trackOptimizelyEvent) {
                    if (isPdpFis) {
                        storeSearchData.trackOptimizelyEvent('click_fis_pdp');
                    }
                    else {
                        storeSearchData.trackOptimizelyEvent('find_in_store_from_favourite');
                    } // TODO: BTBPSDL-200 remove storeSearchData.trackOptimizelyEvent once AB test will complete
                }
                if (productTile.size) {
                    onProductStoreLocatorWithSizeClick === null || onProductStoreLocatorWithSizeClick === void 0 ? void 0 : onProductStoreLocatorWithSizeClick(articleCode);
                }
                else {
                    onProductStoreLocatorCTAClick === null || onProductStoreLocatorCTAClick === void 0 ? void 0 : onProductStoreLocatorCTAClick(articleCode);
                }
                setIsStoreLocatorOpen(true);
            }, disabled: !inStoreStock }, ctaText));
    }
    return (React.createElement(React.Fragment, null,
        findInStoreElement,
        React.createElement(Modal, { isOpen: isStoreLocatorOpen, toggleModal: () => setIsStoreLocatorOpen(!isStoreLocatorOpen), closeButtonText: closeButtonText, onClosed: storeSearchData.onStoreLocatorClosed, modalHeadingClassName: styles.modalHeadingClassName, modalType: "fullScreen", className: styles.scrollRemoved, disableRemoveScroll: true },
            React.createElement(Suspense, { fallback: React.createElement("div", null) },
                React.createElement(Locator, Object.assign({}, storeSearchData, { productTile: productTile, buyOnlineButtonOnClick: () => setIsStoreLocatorOpen(!isStoreLocatorOpen), openSingleStoreModal: openStoreModal, stores: storeSearchData.stores || [], applyScrollLock: isStoreLocatorOpen, shouldShowMyStoreFirst: optimizelyVariantsName === 'variant1', mySelectedStore: mySelectedStore, showStoreCardWithSeparator: showStoreCardWithSeparator })))),
        React.createElement(Modal, { isOpen: !!isStoreOpen, toggleModal: () => setIsStoreOpen(''), onClosing: () => setIsStoreLocatorOpen(true), closeButtonText: closeButtonText, modalType: "fullScreen", disableRemoveScroll: true }, selectedStore && (React.createElement("div", { className: styles.singleStoreContainer, key: selectedStore.storeCode },
            React.createElement(Suspense, { fallback: React.createElement(Spinner, { isRendered: true }) },
                React.createElement(Locator, { store: selectedStore, openingHoursTitle: storeSearchData.openingHoursTitle, openingHourExceptionsTitle: storeSearchData.openingHourExceptionsTitle, singleStoreCustomerServiceText: storeSearchData.singleStoreCustomerServiceText, singleStoreCustomerServiceAriaLabel: storeSearchData.singleStoreCustomerServiceAriaLabel, singleStoreDirectionText: storeSearchData.singleStoreDirectionText, singleStoreDirectionAriaLabel: storeSearchData.singleStoreDirectionAriaLabel, singleStoreTabOneHeading: storeSearchData.singleStoreTabOneHeading, singleStoreTabTwoHeading: storeSearchData.singleStoreTabTwoHeading, trackOptimizelyEvent: storeSearchData.trackOptimizelyEvent, trackPhonenumberFindInStore: storeSearchData.trackPhonenumberFindInStore })))))));
};
export default ProductStoreLocator;
//# sourceMappingURL=ProductStoreLocator.js.map